import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { ActivityIndicator } from 'react-native';
import Text, { H3, Large } from '@dbk/ui-text';
import ScrollableLayout from '../../components/common/scrollable-layout';
import { PALETTE } from '../../constants';
import { LoadingCircle } from '../../components/common/loading';
import styles from './rmcallback.styles';
import classNames from 'classnames';
import callbackOptions from '../../data/callbackoptions.json';
import BlurModal from '../../components/common/blur-modal';
import Button from '@dbk/ui-buttons';
import { Radio } from '@dbk/ui-forms';
import { List, ListItem } from '@dbk/ui-list';

class RMCallBack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      selectedStates: [],
      warningMsg: false,
      rmModal: false,
      displayMsg: '',
      loadingFlag: false
    };

    this.submitRequest = this.submitRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderTabletAssetItem = this.renderTabletAssetItem.bind(this);
    this.deselectAll = this.deselectAll.bind(this);
    this.renderTabletBlock = this.renderTabletBlock.bind(this);
    this.closeRMCallBack = this.closeRMCallBack.bind(this);
  }

  componentDidMount() {
    const {
      i18n: { messages },
      edelivery: { showPrompt },
    } = this.props;
    this.props.callback.setScreen('rmcallback');
    this.deselectAll();
    const basePath = window.location.href.split('/')[4];
    const screen = basePath;
    const arrayList = callbackOptions.options;
    const selectedOptions = [];
    const displayPaperlessStatementQueryOption = showPrompt;
    if (arrayList[4].key === 'edelivery' && (displayPaperlessStatementQueryOption !== undefined && displayPaperlessStatementQueryOption !== 2)) {
      arrayList.splice(4, 1);
    }
    if (screen === messages['app.common.pageTitle.changePass'] || screen === messages['app.common.pageTitle.touchId'] || screen === messages['app.common.pageTitle.mangaeConsolidate'] || screen === messages['app.common.pageTitle.notificationSett'] || screen.includes("Currency") == true || screen === messages['app.common.pageTitle.profile']) {
      arrayList[3].isChecked = true;
      selectedOptions.push(arrayList[3]);
    }
    else if (screen === messages['app.common.pageTitle.reports'] || screen === messages['app.common.pageTitle.monthStat'] || screen === messages['app.common.pageTitle.dailyStat'] || screen === messages['app.common.pageTitle.transactionHistory'] || screen === messages['app.common.pageTitle.monthCurrStat'] || screen === messages['app.common.pageTitle.transAdvice'] || screen === messages['app.common.pageTitle.advice'] || screen.includes("Statement") === true || screen === messages['app.common.pageTitle.correspondence'] || screen.includes("Transaction") == true) {
      arrayList[2].isChecked = true;
      selectedOptions.push(arrayList[2]);
    }
    else if (screen === messages['app.common.pageTitle.maturities']) {
      arrayList[4].isChecked = true;
      selectedOptions.push(arrayList[4]);
    }
    else if (screen.includes("insights") == true) {
      arrayList[1].isChecked = true;
      selectedOptions.push(arrayList[1]);
    }
    else {
      arrayList[0].isChecked = true;
      selectedOptions.push(arrayList[0]);
    }
    this.setState({
      selectedStates: selectedOptions
    });
    this.setState({ displayMsg: this.props.callback.displayMsg });
  }

  componentDidUpdate(prevProp, prevState) {
  }

  componentWillUnmount() {
    this.props.callback.setScreen("other");
  }

  submitRequest() {
    const { selectedStates, warningMsg } = this.state;
    const {
      i18n: { messages },
      edelivery: { showPrompt },
    } = this.props;
    this.setState({ loadingFlag: true });
    // this.setState({ rmModal: true});
    var currentScreen = "";
    if (this.props.ui.history.currentLocation.pathname.substring(24) != "null") {
      currentScreen = this.props.ui.history.currentLocation.pathname.substring(24);
    }
    else {
      currentScreen = this.props.ui.history.currentLocation.pathname.substring(13, 23);
    }
    let input = {
      "screen": messages[currentScreen],
      "context": messages[selectedStates[0].title]
    }
    // this.props.sendRMCallBack({input});
    if (showPrompt == 2 && messages[selectedStates[0].title] == messages['app.rmcallback.eDelivery']) {
      this.props.edelivery.updateUserPreference();
      this.props.edelivery.saveUserPreferences('edelivery-1', input.screen).then((success) => {
        this.setState({ loadingFlag: false });
        this.setState({ rmModal: true });
      });
    } else {
      this.props.sendRMCallBack({ input }).then((success) => {
        this.setState({ loadingFlag: false });
        this.setState({ rmModal: true });
      });
    }
  }
  /*
    function for Deselecting all radiobuttons
  */
  deselectAll() {
    let getList = callbackOptions.options;
    getList.forEach(function (item, k) {
      item.isChecked = false;
    });
  }

  closeRMCallBack() {
    const {
      i18n: { messages },
    } = this.props;
    this.setState({ rmModal: false });
    let pagename = messages[this.props.callback.pagename];
    if (pagename === 'Portfolio') {
      pagename = 'Portfolios';
    }
    this.props.changePage(`/${pagename.toLowerCase()}`);
  }

  handleChange(e, asset) {
    this.deselectAll();
    let arrayList = callbackOptions.options;
    let checkedCountTemp = 0;
    let selectedOptions = [];
    arrayList.forEach(function (dataRow, i) {
      if (dataRow.key == asset.key) {
        dataRow.isChecked = true;
        selectedOptions.push(dataRow)
      }
    });
    this.setState({
      selectedStates: selectedOptions
    });
  }

  renderTabletAssetItem(asset, index) {
    const { title, isChecked, key } = asset;
    const { i18n: { messages } } = this.props;
    return (
      <div className="rmcallback-seperator">
        <div
          onClick={(e) => this.handleChange(e, asset)}
          className={'margin-5'}
        >
          <span className={'margin-left-15'}>
            <Radio
              checked={isChecked}
              onChange={(e) => this.handleChange(e, asset)}
              name="rm_callback"
              value="value"
              id={`radio_${index}_rmcallback_test`}
            />
          </span>
          <span className="margin-left-10">
            <span>
              <Text secondary={isChecked && index ? true : false} id={`radioText_${index}_rmcallback_test`}>
                {messages[title]}
              </Text>
            </span>
          </span>
        </div>
      </div>
    );
  }

  renderTabletBlock() {
    const options = callbackOptions.options;
    if (options != undefined && options != null) {
      return (
        <List fullWidth className="listFullHeight">
          {options.map((item, index) => (
            <ListItem>
              {this.renderTabletAssetItem(item, index)}
            </ListItem>
          ))}
        </List>
      );
    }
  }

  render() {
    const { i18n: { messages }, screen } = this.props;
    let messageText = '';
    const {
      selectedStates, loadingFlag
    } = this.state;
    const { displayMsg, success } = this.props.callback;
    const rowBorderCSS = classNames('row-border', { 'row-border-mobile': screen.isSmall });
    const messageDivCSS = classNames('message-div', { 'message-div-mobile': screen.isSmall });
    const eDeliverySuccess = (selectedStates[0] && selectedStates[0].key) ? ((selectedStates[0].key === 'edelivery') && (displayMsg === messages['app.rmcallback.successMsg'])) : false;
    if (loadingFlag) {
      return (
        <div className="row rmcallback-main-wrapper large-10 medium-10 large-10">
          <div className="centerLoading">
            <ActivityIndicator
              animating
              color={PALETTE.primaryText}
              size="large"
            />
          </div>
        </div>
      )
    }
    return (
      <div>
        <div className="row rmcallback-main-wrapper large-10 medium-10 large-10">
          <div className="margin-bottom-30 profile-container">
            <div secondary className="profile-container__title">
              <h2 id="header_rmcallbackHeader_rmCallback_test">{messages['app.rmcallback.header']}</h2>
            </div>
          </div>
          <div className={messageDivCSS}>
            <Large secondary id="header_rmcallbackSubtitle_rmcallback_test">{messages['app.rmcallback.subTitle']}</Large>
          </div>
          <div className="text-center">
            <Large secondary >{messageText}</Large>
          </div>
          <div className="clearfix"></div>
          <div className={rowBorderCSS}></div>
          {this.renderTabletBlock()}
          <div className="button-continue">
            <Button
              loading={loadingFlag ? true : false}
              onClick={() => this.submitRequest()}
              testID="btn_submit_rmCallback_test"
            >
              {messages['app.rmcallback.subReq']}
            </Button>
          </div>
        </div>
        {this.state.rmModal ? <BlurModal
          visible={this.state.rmModal}
          style={styles.mainWrapper}
          onDone={this.closeRMCallBack}
          disableDone={true}>
          <div className="popup">
            <div className="starrating-container noBorder">
              <div className="text-center margin-bottom-30">
                {(success || eDeliverySuccess) ?
                  <H3 secondary id="text_reqSub_rmcallback_test">
                    {messages['app.rmcallback.reqSub']}
                  </H3>
                  :
                  <H3></H3>
                }
              </div>
              <div className="text-center message-text">
                <Large secondary id="text_modalMessage_rmcallback_test">{displayMsg}</Large>
              </div>
              <div className="text-center">
                <div className="margin-top-50">
                  <div style={{ width: 200, margin: '0 auto' }}>
                    <Button
                      loading={loadingFlag ? true : false}
                      onClick={() => this.closeRMCallBack()}
                      testID="btn_ok_rmcallback_test"
                    >
                      {messages['app.rmcallback.okMsg']}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BlurModal> : null}
      </div>

    );
  }
}
export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle />,
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      }
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    screen: {
      width: true,
      height: true,
      isSmall: true
    },
    sendRMCallBack:
    {
      $call: 'callback.getResponse'
    },
    callback: {
      displayMsg: true,
      success: true,
      screen: true,
      pagename: true,
      setScreen: { $call: 'setScreen' },
    },
    ui: {
      history: {
        canGoBack: true,
        goBack: { $call: 'goBack' },
        currentLocation: {
          pathname: true,
        }
      },
    },
    edelivery: {
      showPrompt: true,
      updateUserPreference: { $call: 'updateUserPreference' },
      saveUserPreferences: { $call: 'saveUserPreferences' },
    },
  },
}, ({ app, ...queries }) => ({
  deviceInfo: app.global.deviceInfo,
  ...queries,
}))(RMCallBack);
